var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcTickCircle = function SvgIcTickCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "6E4C34CA-776E-4CC3-AFAA-09B3510B771F")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zmiana-instytucji",
    transform: "translate(-1350.000000, -387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kafel-02",
    transform: "translate(990.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(360.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6105104,9.10273948 C18.9368227,8.65716264 19.5625624,8.56047962 20.0081393,8.88679191 C20.419441,9.18800327 20.5334604,9.7443481 20.2919146,10.1786156 L20.2240869,10.2844209 L13.8067883,19.047191 C13.4761775,19.4986375 12.8467174,19.5857404 12.4081184,19.2625403 L12.3172327,19.1869863 L8.72263804,15.8278963 C8.31911898,15.4508143 8.29768748,14.8180121 8.67476945,14.4144931 C9.02284512,14.0420139 9.58881255,13.9951005 9.99120351,14.2866723 L10.0881726,14.3666245 L12.859,16.956 L18.6105104,9.10273948 Z",
    id: "ptaszek",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTickCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tick_circle.7b23bf09.svg";
export { ForwardRef as ReactComponent };